import { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import { getValidationModes, skipValidation, EVENTS } from '../../utils/react-hook-form'

export const useFieldValidation = (name) => {
	const {
		control,
		trigger,
		formState: { isSubmitted },
		getFieldState,
	} = useFormContext()
	const { isTouched } = getFieldState(name)

	return useCallback(
		async (event) => {
			const isBlurEvent = event?.type === EVENTS.BLUR || event?.type === EVENTS.FOCUS_OUT
			const validationModeBeforeSubmit = getValidationModes(control._options.mode)
			const validationModeAfterSubmit = getValidationModes(control._options.reValidateMode)

			const shouldSkipValidation = skipValidation(
				isBlurEvent,
				isTouched,
				isSubmitted,
				validationModeAfterSubmit,
				validationModeBeforeSubmit
			)
			if (!shouldSkipValidation) {
				await trigger(name)
			}
		},
		[control._options.mode, control._options.reValidateMode, isTouched, isSubmitted, trigger, name]
	)
}
